.cardBackground {
    background: linear-gradient(92.15deg, var(--mantine-color-gray-9) 0.22%, var(--mantine-color-dark-7) 100%);
}
